import { Article } from '../types/articles';
import blockSocials from '../assets/images/blockSocials3.png';
import facebook from '../assets/images/facebook.png';
import youtube from '../assets/images/youtube.png';
import instagram from '../assets/images/instagram.png';
import tiktok from '../assets/images/tiktok.png';
import snapchat from '../assets/images/snapchat.png';
import twitter from '../assets/images/twitter.png';
import reddit from '../assets/images/reddit.png';
import clashRoyale from '../assets/images/clashRoyale.png';
import clashOfClans from '../assets/images/clashOfClans.png';
import lockin from '../assets/images/lockin.jpeg';
import noPorn from '../assets/images/noPorn.jpeg';

export const articles: Article[] = [
  {
    id: '1',
    title: 'How To Block Apps on iPhone [2025]',
    subtitle: 'Learn the most effective ways to block distracting apps on your iPhone with Upshift',
    mainImage: blockSocials,
    htmlContentPath: '/articles/how-to-block-apps-iphone-upshift.html',
    slug: 'how-to-block-apps-iphone-upshift',
    publishedDate: '2025-01-01T00:00:00Z'
  },
  {
    id: '2',
    title: 'How To Block Websites on iPhone (Safari or Chrome)',
    subtitle: 'Complete guide to blocking websites on iPhone using built-in tools and Upshift',
    mainImage: blockSocials,
    htmlContentPath: '/articles/how-to-block-websites-iphone-upshift.html',
    slug: 'how-to-block-websites-iphone-upshift',
    publishedDate: '2025-01-02T00:00:00Z'
  },
  {
    id: '3',
    title: 'How To Use App Blockers: A Scientific Approach To Reducing Screen Time',
    subtitle: 'Learn how to use app blockers like Upshift to limit screen time and regain control',
    mainImage: blockSocials,
    htmlContentPath: '/articles/app-blockers-science-upshift.html',
    slug: 'app-blockers-science-upshift',
    publishedDate: '2025-01-03T00:00:00Z'
  },
  {
    id: '4',
    title: 'How To Limit Screen Time on iPhone: 6 Proven Tips [2025]',
    subtitle: '7 actionable steps for reducing time spent on your phone with Upshift and other methods',
    mainImage: lockin,
    htmlContentPath: '/articles/how-to-limit-screen-time-iphone-upshift.html',
    slug: 'how-to-limit-screen-time-iphone-upshift',
    publishedDate: '2025-01-04T00:00:00Z'
  },
  // {
  //   id: '5',
  //   title: 'How To Lock Apps on iPhone',
  //   subtitle: 'Learn how to lock & hide apps on iPhone using iOS 18 features and Upshift',
  //   mainImage: blockSocials,
  //   htmlContentPath: '/articles/how-to-lock-apps-iphone-upshift.html',
  //   slug: 'how-to-lock-apps-iphone-upshift'
  // },
  {
    id: '6',
    title: 'How To Set Time Limits on iPhone [2025]',
    subtitle: 'Learn how to set time limits on apps using Apple Screen Time and Upshift',
    mainImage: lockin,
    htmlContentPath: '/articles/how-to-time-limit-iphone-upshift.html',
    slug: 'how-to-time-limit-iphone-upshift',
    publishedDate: '2025-01-05T00:00:00Z'
  },
  {
    id: '7',
    title: 'How To Block YouTube on iPhone',
    subtitle: 'Learn how to block YouTube on iPhone using built-in tools and Upshift',
    mainImage: youtube,
    htmlContentPath: '/articles/how-to-block-youtube-iphone-upshift.html',
    slug: 'how-to-block-youtube-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '8',
    title: 'How To Block Instagram on iPhone',
    subtitle: 'Learn how to block Instagram on iPhone using built-in tools and Upshift',
    mainImage: instagram,
    htmlContentPath: '/articles/how-to-block-instagram-iphone-upshift.html',
    slug: 'how-to-block-instagram-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '9',
    title: 'How To Block Facebook on iPhone',
    subtitle: 'Learn how to block Facebook on iPhone using built-in tools and Upshift',
    mainImage: facebook,
    htmlContentPath: '/articles/how-to-block-facebook-iphone-upshift.html',
    slug: 'how-to-block-facebook-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '10',
    title: 'How To Block Tiktok on iPhone',
    subtitle: 'Learn how to block Tiktok on iPhone using built-in tools and Upshift',
    mainImage: tiktok,
    htmlContentPath: '/articles/how-to-block-tiktok-iphone-upshift.html',
    slug: 'how-to-block-tiktok-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '11',
    title: 'How To Block Snapchat on iPhone',
    subtitle: 'Learn how to block Snapchat on iPhone using built-in tools and Upshift',
    mainImage: snapchat,
    htmlContentPath: '/articles/how-to-block-snapchat-upshift.html',
    slug: 'how-to-block-snapchat-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '12',
    title: 'How To Block Twitter on iPhone',
    subtitle: 'Learn how to block Twitter on iPhone using built-in tools and Upshift',
    mainImage: twitter,
    htmlContentPath: '/articles/how-to-block-twitter-iphone-upshift.html',
    slug: 'how-to-block-twitter-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '13',
    title: 'How To Block Reddit on iPhone',
    subtitle: 'Learn how to block Reddit on iPhone using built-in tools and Upshift',
    mainImage: reddit,
    htmlContentPath: '/articles/how-to-block-reddit-iphone-upshift.html',
    slug: 'how-to-block-reddit-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '13',
    title: 'How To Block Clash Royale on iPhone',
    subtitle: 'Learn how to block Clash Royale on iPhone using built-in tools and Upshift',
    mainImage: clashRoyale,
    htmlContentPath: '/articles/how-to-block-clash-royale-upshift.html',
    slug: 'how-to-block-clash-royale-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '13',
    title: 'How To Block Clash of Clans on iPhone',
    subtitle: 'Learn how to block Clash of Clans on iPhone using built-in tools and Upshift',
    mainImage: clashOfClans,
    htmlContentPath: '/articles/how-to-block-clash-of-clans-iphone-upshift.html',
    slug: 'how-to-block-clash-of-clans-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },

  {
    id: '14',
    title: 'How To Block Porn on iPhone',
    subtitle: 'Learn how to block porn on iPhone using built-in tools and Upshift',
    mainImage: noPorn,
    htmlContentPath: '/articles/how-to-block-porn-iphone-upshift.html',
    slug: 'how-to-block-porn-iphone-upshift',
    publishedDate: '2025-01-06T00:00:00Z'
  },
  {
    id: '15',
    title: 'Why Do I Feel So Unmotivated? 9 Reasons and 6 Solutions',
    subtitle: 'Learn how to block porn on iPhone using built-in tools and Upshift',
    mainImage: blockSocials,
    htmlContentPath: '/articles/why-feel-unmotivated-upshift.html',
    slug: 'why-feel-unmotivated-upshift',
    publishedDate: '2025-01-07T00:00:00Z'
  },
  {
    id: '16',
    title: 'How To Limit Screen Time on iPhone: 7 Proven Tips to Boost Productivity [Updated 2025]',
    subtitle: 'Learn how to stop procrastinating',
    mainImage: lockin,
    htmlContentPath: '/articles/how-to-limit-screen-time-iphone-upshift.html',
    slug: 'how-to-stop-procrastinating-upshift',
    publishedDate: '2025-01-07T00:00:00Z'
  }

];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(article => article.slug === slug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(article => article.id === id);
};
